// extracted by mini-css-extract-plugin
export var container = "styles-module--container--d282d";
export var containerBordered = "styles-module--container--bordered--ee591";
export var containerNoDesktopTop = "styles-module--container--no-desktop-top--8812d";
export var content = "styles-module--content--d4ebb";
export var content_image_container = "styles-module--content_image_container--d47ae";
export var content_image_container_img = "styles-module--content_image_container_img--d9389";
export var content_link = "styles-module--content_link--1fd1d";